<template>
  <div class="StatusComponentClass">
    <div v-if="this.status !== undefined" class="row mx-auto" :style="cssVars" :class="{'bg-whitesmoke': isSmallStatusComponent}">
      <div v-if="firstStep.showStepText === false" class="icon my-auto mr-0 ml-0" :class="{'icon-done-modifier': firstStep.stepName === 'UPLOADED', 'icon-Real-time': firstStep.stepName === 'UPLOADING'}" :style="{'color': firstStep.stepColor, 'height': iconFontSize, 'width': iconFontSize, 'font-size': iconFontSize}" :title="firstStep.stepName"></div>
      <div v-if="firstStep.showStepText === true" class="border border-600 rounded my-auto row mr-0 ml-0 pr-1 pl-1">
        <div class="icon my-auto mr-0 ml-0" :class="{'icon-done-modifier': firstStep.stepName === 'UPLOADED', 'icon-Real-time': firstStep.stepName === 'UPLOADING'}" :style="{'color': firstStep.stepColor, 'height': iconFontSize, 'width': iconFontSize, 'font-size': iconFontSize}" :title="firstStep.stepName"></div>
        <div class="my-auto" :style="{'font-size': statusTextFontSize}">{{firstStep.stepName}}</div>
      </div>
      <div class="pl-0 pr-0 my-auto">
        <div class="progress-bar pl-1" :class="{'col-2': !isSmallStatusComponent, 'pr-1': isSmallStatusComponent}"></div>
      </div>
      <div v-if="secondStep.showStepText === false" class="icon my-auto mr-0 ml-0" :class="{'icon-modifier-no-access': secondStep.stepName === 'NOT STARTED YET', 'icon-done-modifier': secondStep.stepName === 'PRE PROCESSED', 'icon-Modifier-delete': ['PRE PROCESSING IN ERROR', 'PRE PROCESSING FAILED'].includes(secondStep.stepName), 'icon-Real-time': secondStep.stepName === 'PRE PROCESSING IN PROGRESS'}" :style="{'color': secondStep.stepColor, 'height': iconFontSize, 'width': iconFontSize, 'font-size': iconFontSize}" :title="secondStep.stepName"></div>
      <div v-if="secondStep.showStepText === true" class="border border-600 rounded my-auto row mr-0 ml-0 pr-1 pl-1">
        <div class="icon my-auto mr-0 ml-0" :class="{'icon-modifier-no-access': secondStep.stepName === 'NOT STARTED YET', 'icon-done-modifier': secondStep.stepName === 'PRE PROCESSED', 'icon-Modifier-delete': ['PRE PROCESSING IN ERROR', 'PRE PROCESSING FAILED'].includes(secondStep.stepName), 'icon-Real-time': secondStep.stepName === 'PRE PROCESSING IN PROGRESS', 'blink': secondStep.stepName === 'PRE PROCESSING IN PROGRESS'}" :style="{'color': secondStep.stepColor, 'height': iconFontSize, 'width': iconFontSize, 'font-size': iconFontSize}" :title="secondStep.stepName"></div>
        <div class="my-auto" :class="{'blink': secondStep.stepName === 'PRE PROCESSING IN PROGRESS'}" :style="{'font-size': statusTextFontSize}">{{secondStep.stepName}}</div>
      </div>
      <div class="pl-0 pr-0 my-auto">
        <div class="progress-bar pl-1"  :class="{'col-2': !isSmallStatusComponent, 'pr-1': isSmallStatusComponent}"></div>
      </div>
      <div v-if="thirdStep.showStepText === false" class="icon my-auto mr-0 ml-0" :class="{'icon-modifier-no-access': thirdStep.stepName === 'NOT STARTED YET', 'icon-done-modifier': thirdStep.stepName === 'ANNOTATED', 'icon-Modifier-delete': ['ANNOTATION IN ERROR', 'ANNOTATION FAILED'].includes(thirdStep.stepName), 'icon-Real-time': thirdStep.stepName === 'ANNOTATION IN PROGRESS'}" :style="{'color': thirdStep.stepColor, 'height': iconFontSize, 'width': iconFontSize, 'font-size': iconFontSize}"  :title="thirdStep.stepName"></div>
      <div v-if="thirdStep.showStepText === true" class="border border-600 rounded my-auto row mr-0 ml-0 pr-1 pl-1">
        <div class="icon my-auto mr-0 ml-0" :class="{'icon-modifier-no-access': thirdStep.stepName === 'NOT STARTED YET', 'icon-done-modifier': thirdStep.stepName === 'ANNOTATED', 'icon-Modifier-delete': ['ANNOTATION IN ERROR', 'ANNOTATION FAILED'].includes(thirdStep.stepName), 'icon-Real-time': thirdStep.stepName === 'ANNOTATION IN PROGRESS', 'blink': thirdStep.stepName === 'ANNOTATION IN PROGRESS'}" :style="{'color': thirdStep.stepColor, 'height': iconFontSize, 'width': iconFontSize, 'font-size': iconFontSize}"  :title="thirdStep.stepName"></div>
        <div class="my-auto" :class="{'blink': thirdStep.stepName === 'ANNOTATION IN PROGRESS'}" :style="{'font-size': statusTextFontSize}">{{thirdStep.stepName}}</div>
      </div>
    </div>
  </div>
</template>
<script>

const STEP_TYPE_NOT_STARTED = `notStarted`;
const STEP_TYPE_IN_PROGRESS = `inProgress`;
const STEP_TYPE_IN_ERROR_OR_FAILURE = `inErrorOrFailure`;
const STEP_TYPE_DONE = `done`;

const STEP_COLOR_BLUE = `#049dff`;
const STEP_COLOR_RED = `#ed687c`;
const STEP_COLOR_GREEN = `#1abc9c`;
const STEP_COLOR_GREY = `#cccccc`;

export default {
  name: "StatusComponent",
  components: {},
  props: ["status", "SmallStatusComponent"],
  data() {
    return {
    }
  },
  mounted() {
  },
  computed: {
    isSmallStatusComponent: function() {
      return this.SmallStatusComponent === true;
    },
    firstStep: function() {
      if (this.status === undefined) {
        return {
          stepName: undefined,
          stepType: undefined,
          stepColor: STEP_COLOR_GREY,
          showStepText: false
        }
      } else if ([`UPLOADING`].includes(this.status)) {
        return {
          stepName: `UPLOADING`,
          stepType: STEP_TYPE_IN_PROGRESS,
          stepColor: STEP_COLOR_BLUE,
          showStepText: !this.isSmallStatusComponent
        };
      } else {
        return {
          stepName: `UPLOADED`,
          stepType: STEP_TYPE_DONE,
          stepColor: STEP_COLOR_GREEN,
          showStepText: !this.isSmallStatusComponent && [`UPLOADED`].includes(this.status)
        };
      }
    },
    secondStep: function() {
      if (this.status === undefined) {
        return {
          stepName: undefined,
          stepType: undefined,
          stepColor: STEP_COLOR_GREY,
          showStepText: false
        }
      } else if ([`UPLOADING`, `UPLOADED`].includes(this.status)) {
        return {
          stepName: `NOT STARTED YET`,
          stepType: STEP_TYPE_NOT_STARTED,
          stepColor: STEP_COLOR_GREY,
          showStepText: false
        };
      } else if ([`PRE PROCESSING IN PROGRESS`].includes(this.status)) {
        return {
          stepName: `PRE PROCESSING IN PROGRESS`,
          stepType: STEP_TYPE_IN_PROGRESS,
          stepColor: STEP_COLOR_BLUE,
          showStepText: !this.isSmallStatusComponent
        };
      } else if ([`PRE PROCESSING IN ERROR`].includes(this.status)) {
        return {
          stepName: `PRE PROCESSING IN ERROR`,
          stepType: STEP_TYPE_IN_ERROR_OR_FAILURE,
          stepColor: STEP_COLOR_RED,
          showStepText: !this.isSmallStatusComponent
        };
      } else if ([`PRE PROCESSING FAILED`].includes(this.status)) {
        return {
          stepName: `PRE PROCESSING FAILED`,
          stepType: STEP_TYPE_IN_ERROR_OR_FAILURE,
          stepColor: STEP_COLOR_RED,
          showStepText: !this.isSmallStatusComponent
        };
      } else {
        return {
          stepName: `PRE PROCESSED`,
          stepType: STEP_TYPE_DONE,
          stepColor: STEP_COLOR_GREEN,
          showStepText: !this.isSmallStatusComponent && [`PRE PROCESSING DONE`, `PRE PROCESSING IN ERROR`, `PRE PROCESSING FAILED`].includes(this.status)
        };
      }
    },
    thirdStep: function() {
      if (this.status === undefined) {
        return {
          stepName: undefined,
          stepType: undefined,
          stepColor: STEP_COLOR_GREY,
          showStepText: false
        }
      } else if ([`UPLOADING`, `UPLOADED`, `PRE PROCESSING IN PROGRESS`, `PRE PROCESSING DONE`, `PRE PROCESSING IN ERROR`, `PRE PROCESSING FAILED`].includes(this.status)) {
        return {
          stepName: `NOT STARTED YET`,
          stepType: STEP_TYPE_NOT_STARTED,
          stepColor: STEP_COLOR_GREY,
          showStepText: false
        };
      } else if ([`ANNOTATION IN PROGRESS`].includes(this.status)) {
        return {
          stepName: `ANNOTATION IN PROGRESS`,
          stepType: STEP_TYPE_IN_PROGRESS,
          stepColor: STEP_COLOR_BLUE,
          showStepText: !this.isSmallStatusComponent
        };
      } else if ([`ANNOTATION IN ERROR`].includes(this.status)) {
        return {
          stepName: `ANNOTATION IN ERROR`,
          stepType: STEP_TYPE_IN_ERROR_OR_FAILURE,
          stepColor: STEP_COLOR_RED,
          showStepText: !this.isSmallStatusComponent
        };
      } else if ([`ANNOTATION FAILED`].includes(this.status)) {
        return {
          stepName: `ANNOTATION FAILED`,
          stepType: STEP_TYPE_IN_ERROR_OR_FAILURE,
          stepColor: STEP_COLOR_RED,
          showStepText: !this.isSmallStatusComponent
        };
      } else {
        return {
          stepName: `ANNOTATED`,
          stepType: STEP_TYPE_DONE,
          stepColor: STEP_COLOR_GREEN,
          showStepText: !this.isSmallStatusComponent
        };
      }
    },
    iconFontSize: function() {
      return '20px';
    },
    statusTextFontSize: function() {
      return '10px';
    },
    cssVars: function() {
      return {
        '--color': '#cccccc'
      }
    }
  },
  methods: {
    defineProgressBarColorFromRotateDeg: function(deg) {
      if (deg === undefined) {
        return '#1abc9c'; // green
      } else if (deg < 90) {
        return '#ed687c'; // pink
      } else if (deg < 180) {
        return '#fdba04'; // yellow
      } else if (deg < 270) {
        return '#1abc9c'; // green
      } else {
        return '#049dff'; // blue
      }
    }
  }
};
</script>
<style scoped>

.progress-bar{
  /* width: 30%; */
  height: 0.3rem;
  background-color: var(--color);
  border-color: var(--color);
  font-size: var(--fontSize);
}

.StatusComponentClass{
  line-height: 22.5px
}

.blink {
  animation: blinker 2s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.5;
  }
}

</style>